module.exports = __webpack_public_path__ + "static/media/no-code-icon.f77425ec.svg";